/**
 * Box2Go: agrupa líneas con properties[box2go_grupo] y properties[Caja].
 * Registro en sessionStorage + sincronización con /cart.js al abrir el menú.
 */
(function () {
  const STORAGE_ID = 'box2go_caja_id';
  const STORAGE_NUM = 'box2go_caja_numero';
  const STORAGE_LABEL_OVERRIDE = 'box2go_caja_label_override';
  const STORAGE_REGISTRY = 'box2go_registry';

  function randomId() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return crypto.randomUUID();
    }
    return 'caja-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function getRegistry() {
    try {
      const raw = sessionStorage.getItem(STORAGE_REGISTRY);
      const arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function saveRegistry(list) {
    try {
      sessionStorage.setItem(STORAGE_REGISTRY, JSON.stringify(list));
    } catch (e) {
      /* ignore */
    }
  }

  function parseCajaNum(label) {
    if (!label || typeof label !== 'string') return 0;
    const m = /^caja personalizada (\d+)$/i.exec(label.trim());
    return m ? parseInt(m[1], 10) : 0;
  }

  function mergeRegistryFromCart(cart) {
    const byId = new Map(getRegistry().map((x) => [x.id, x]));
    (cart.items || []).forEach(function (item) {
      const p = item.properties || {};
      if (String(p._box2go_packaging) === '1') return;
      const id = p.box2go_grupo;
      const label = p.Caja;
      if (!id || !label) return;
      const idStr = String(id);
      const labelStr = String(label);
      const prev = byId.get(idStr);
      if (!prev) {
        byId.set(idStr, { id: idStr, label: labelStr });
        return;
      }
      const n = parseCajaNum(labelStr);
      const pn = parseCajaNum(prev.label);
      // Mismo id = misma caja: quedarse con el menor número (evita que líneas mal etiquetadas suban el nombre).
      const useNew =
        (pn === 0 && n > 0) || (n > 0 && pn > 0 && n < pn) || (n > 0 && pn === 0);
      if (useNew) {
        byId.set(idStr, { id: idStr, label: labelStr });
      }
    });
    saveRegistry(Array.from(byId.values()));
  }

  /**
   * Si la caja activa (mismo box2go_grupo) ya está en el registro/carrito, sincroniza STORAGE_NUM con su etiqueta.
   * Solo sube el contador cuando el id actual es nuevo y chocaría con números ya usados (sesión nueva + carrito con cajas).
   */
  function ensureNumeroCoherent() {
    const currentId = String(getCajaId());
    const list = getRegistry();
    const mine = list.find(function (x) {
      return x.id === currentId;
    });
    if (mine) {
      const n = parseCajaNum(mine.label);
      if (n > 0) {
        try {
          sessionStorage.setItem(STORAGE_NUM, String(n));
        } catch (e) {
          /* ignore */
        }
      }
      return;
    }
    let maxLab = 0;
    list.forEach(function (x) {
      maxLab = Math.max(maxLab, parseCajaNum(x.label));
    });
    const num = getCajaNumero();
    if (maxLab > 0 && num <= maxLab) {
      try {
        sessionStorage.setItem(STORAGE_NUM, String(maxLab + 1));
      } catch (e) {
        /* ignore */
      }
    }
  }

  function registerCaja(id, label) {
    if (!id || !label) return;
    const list = getRegistry();
    const idStr = String(id);
    const labelStr = String(label);
    const idx = list.findIndex((x) => x.id === idStr);
    if (idx === -1) {
      list.push({ id: idStr, label: labelStr });
    } else {
      const n = parseCajaNum(labelStr);
      const pn = parseCajaNum(list[idx].label);
      const useNew =
        (pn === 0 && n > 0) || (n > 0 && pn > 0 && n < pn) || (n > 0 && pn === 0);
      if (useNew) {
        list[idx] = { id: idStr, label: labelStr };
      }
    }
    saveRegistry(list);
  }

  function getCajaId() {
    try {
      let id = sessionStorage.getItem(STORAGE_ID);
      if (!id) {
        id = randomId();
        sessionStorage.setItem(STORAGE_ID, id);
      }
      return id;
    } catch (e) {
      return randomId();
    }
  }

  function getCajaNumero() {
    try {
      const n = parseInt(sessionStorage.getItem(STORAGE_NUM) || '1', 10);
      return Number.isFinite(n) && n > 0 ? n : 1;
    } catch (e) {
      return 1;
    }
  }

  function getCajaLabel() {
    try {
      const override = sessionStorage.getItem(STORAGE_LABEL_OVERRIDE);
      if (override) return override;
    } catch (e) {
      /* ignore */
    }
    return 'Caja personalizada ' + getCajaNumero();
  }

  function getMaxCajaNumber() {
    let max = 0;
    getRegistry().forEach(function (x) {
      max = Math.max(max, parseCajaNum(x.label));
    });
    try {
      const ov = sessionStorage.getItem(STORAGE_LABEL_OVERRIDE);
      if (ov) max = Math.max(max, parseCajaNum(ov));
      max = Math.max(max, parseInt(sessionStorage.getItem(STORAGE_NUM) || '1', 10));
    } catch (e) {
      /* ignore */
    }
    return max;
  }

  /** Nueva caja: nuevo id y siguiente número disponible. */
  function nuevaCaja() {
    try {
      const next = getMaxCajaNumber() + 1;
      sessionStorage.removeItem(STORAGE_LABEL_OVERRIDE);
      sessionStorage.setItem(STORAGE_NUM, String(next));
      sessionStorage.setItem(STORAGE_ID, randomId());
    } catch (e) {
      /* ignore */
    }
    announce(getCajaLabel());
    window.dispatchEvent(new CustomEvent('box2go:caja-cambiada', { detail: { label: getCajaLabel() } }));
  }

  /** Volver a agregar piezas a una caja ya usada en el carrito (mismo id y etiqueta). */
  function seleccionarCaja(id) {
    const list = getRegistry();
    const found = list.find(function (x) {
      return x.id === id;
    });
    if (!found) return;
    try {
      sessionStorage.setItem(STORAGE_ID, found.id);
      sessionStorage.setItem(STORAGE_LABEL_OVERRIDE, found.label);
    } catch (e) {
      /* ignore */
    }
    announce('Agregando a: ' + found.label);
    window.dispatchEvent(
      new CustomEvent('box2go:caja-cambiada', { detail: { label: found.label, id: found.id } })
    );
  }

  /** Carrito vacío o vaciar carrito: nueva caja 1 y registro limpio. */
  function resetBox2goCajaSession() {
    try {
      sessionStorage.removeItem(STORAGE_ID);
      sessionStorage.removeItem(STORAGE_NUM);
      sessionStorage.removeItem(STORAGE_LABEL_OVERRIDE);
      sessionStorage.removeItem(STORAGE_REGISTRY);
    } catch (e) {
      /* ignore */
    }
    announce(getCajaLabel());
    window.dispatchEvent(new CustomEvent('box2go:caja-cambiada', { detail: { label: getCajaLabel() } }));
  }

  function announce(msg) {
    var live = document.getElementById('Box2GoLiveRegion');
    if (live) live.textContent = msg;
    var menu = document.getElementById('Box2GoCajaMenu');
    if (menu) {
      var sum = menu.querySelector('.box2go-caja-menu__summary');
      if (sum) sum.setAttribute('title', msg);
    }
  }

  function injectProperties(form) {
    form.querySelectorAll('[data-box2go-injected]').forEach((el) => el.remove());
    const id = getCajaId();
    const label = getCajaLabel();
    registerCaja(id, label);
    [['properties[box2go_grupo]', id], ['properties[Caja]', label]].forEach(([name, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      input.setAttribute('data-box2go-injected', '');
      form.appendChild(input);
    });
  }

  function injectIfPiezaForm(form) {
    if (!(form instanceof HTMLFormElement)) return;
    if (form.getAttribute('data-type') !== 'add-to-cart-form') return;
    if (form.getAttribute('data-box2go-pieza') !== 'true') return;
    injectProperties(form);
  }

  function closeBox2goMenu() {
    var menu = document.getElementById('Box2GoCajaMenu');
    if (menu && menu.open) menu.removeAttribute('open');
  }

  function populateMenuList() {
    var ul = document.getElementById('Box2GoCajaMenuList');
    var empty = document.getElementById('Box2GoCajaMenuEmpty');
    var curEl = document.getElementById('Box2GoCajaMenuCurrent');
    if (!ul || !empty) return;

    if (curEl) {
      curEl.textContent = 'Ahora: ' + getCajaLabel();
    }

    ul.innerHTML = '';
    empty.classList.add('hidden');

    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        mergeRegistryFromCart(cart);
        ensureNumeroCoherent();
        var currentId = getCajaId();
        var items = getRegistry().slice().sort(function (a, b) {
          return parseCajaNum(a.label) - parseCajaNum(b.label);
        });
        var others = items.filter(function (x) {
          return x.id !== currentId;
        });

        if (others.length === 0) {
          empty.classList.remove('hidden');
          return;
        }

        others.forEach(function (x) {
          var li = document.createElement('li');
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'box2go-caja-menu__item';
          b.setAttribute('role', 'menuitem');
          b.textContent = x.label;
          b.dataset.box2goSelectId = x.id;
          li.appendChild(b);
          ul.appendChild(li);
        });
      })
      .catch(function () {
        var items = getRegistry().filter(function (x) {
          return x.id !== getCajaId();
        });
        if (items.length === 0) {
          empty.classList.remove('hidden');
          return;
        }
        items
          .sort(function (a, b) {
            return parseCajaNum(a.label) - parseCajaNum(b.label);
          })
          .forEach(function (x) {
            var li = document.createElement('li');
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'box2go-caja-menu__item';
            b.setAttribute('role', 'menuitem');
            b.textContent = x.label;
            b.dataset.box2goSelectId = x.id;
            li.appendChild(b);
            ul.appendChild(li);
          });
      });
  }

  document.addEventListener(
    'submit',
    function (e) {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      injectIfPiezaForm(form);
    },
    true
  );

  window.Box2GoCaja = {
    getCajaId,
    getCajaLabel,
    nuevaCaja,
    seleccionarCaja,
    getRegistry,
    populateMenuList,
    resetBox2goCajaSession,
  };
  window.Box2GoCajaInject = injectIfPiezaForm;

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (!event || !event.cartData) return;
        if (event.cartData.item_count === 0) {
          resetBox2goCajaSession();
        }
      });
    }

    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-box2go-empty-cart]');
      if (!t) return;
      e.preventDefault();
      var url = (window.routes && window.routes.cart_clear_url) || '/cart/clear.js';
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      })
        .then(function (r) {
          if (!r.ok) throw new Error();
          resetBox2goCajaSession();
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        })
        .catch(function () {});
    });

    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (!cart.item_count) {
          resetBox2goCajaSession();
          return;
        }
        mergeRegistryFromCart(cart);
        ensureNumeroCoherent();
      })
      .catch(function () {});

    var menu = document.getElementById('Box2GoCajaMenu');
    if (menu) {
      menu.addEventListener('toggle', function () {
        if (menu.open) populateMenuList();
      });

      var btnNew = menu.querySelector('[data-box2go-action="new"]');
      if (btnNew) {
        btnNew.addEventListener('click', function (e) {
          e.preventDefault();
          nuevaCaja();
          closeBox2goMenu();
        });
      }

      menu.addEventListener('click', function (e) {
        var t = e.target.closest('[data-box2go-select-id]');
        if (!t || !menu.contains(t)) return;
        e.preventDefault();
        seleccionarCaja(t.getAttribute('data-box2go-select-id'));
        closeBox2goMenu();
      });

      document.addEventListener('click', function (e) {
        if (!menu.open) return;
        if (menu.contains(e.target)) return;
        closeBox2goMenu();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && menu.open) closeBox2goMenu();
      });
    }
  });
})();
